import type { AppNavRoles } from "../../app.routing";
import { AppProperties } from "../../app.properties";

export interface SubChildrenItems {
  path: string;
  title: string;
  ab?: string;
  icontype?: string;
  requiredRoles?: string[];
}

export interface ChildrenItems {
  path?: string;
  title: string;
  ab?: string;
  type?: string;
  icontype?: string;
  children?: SubChildrenItems[];
  requiredRoles?: string[];
  collapse?: string;
  action?: string;
}

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
  roles?: string[];
  disabled?: boolean;
}

export function getSidebarRoutes(navRoles: AppNavRoles): RouteInfo[] {
  return [
    {
      path: "/mi-portal",
      title: "Mi Portal",
      type: "sub",
      icontype: "person",
      collapse: "mi-portal",
      roles: [...navRoles.miPortal.any],
      children: [
        {
          path: "/mi-portal/mis-vacaciones",
          title: "Mis Vacaciones",
          icontype: "beach_access",
          requiredRoles: [...navRoles.miPortal.misVacaciones],
        },
        {
          path: "/mi-portal/mis-liquidaciones",
          title: "Mis Recibos",
          icontype: "description",
          requiredRoles: [...navRoles.miPortal.misLiquidaciones],
        },
        {
          path: "/mi-portal/mis-liquidaciones-subcontrato",
          title: "Mis Liquidaciones Subcontrato",
          icontype: "receipt_long",
          requiredRoles: [...navRoles.miPortal.misLiquidacionesSubcontrato],
        },
      ],
    },
    {
      path: "/finanzas",
      title: "Adm. & Finanzas",
      type: "sub",
      icontype: "receipt",
      collapse: "finanzas",
      roles: [...navRoles.finanzas.any],
      children: [
        {
          path: "/finanzas/centro-costo",
          title: "Centros de Costos",
          icontype: "account_balance",
          requiredRoles: [...navRoles.finanzas.centroCosto],
        },
        {
          path: "/finanzas/cuentas-cargo",
          title: "Cuentas de Cargos",
          requiredRoles: [...navRoles.finanzas.cuentasCargo],
        },
        {
          path: "/finanzas/liquidaciones-sueldo",
          title: "Liquidaciones de Sueldo",
          requiredRoles: [...navRoles.finanzas.liquidacionesSueldo],
        },
        {
          path: "/finanzas/facturacion",
          title: "Facturación",
          icontype: "receipt_long",
          requiredRoles: [...navRoles.finanzas.any],
        },
      ],
    },
    {
      path: "/personas",
      title: "Personas",
      type: "sub",
      icontype: "supervised_user_circle",
      collapse: "personas",
      roles: [...navRoles.personas.any],
      children: [
        {
          path: "/personas/list",
          title: "Personas",
          icontype: "people",
          requiredRoles: [...navRoles.personas.listPersonas],
        },
        {
          path: "",
          title: "Reclutamiento",
          type: "sub",
          icontype: "work",
          collapse: "reclutamiento",
          requiredRoles: [...navRoles.personas.reclutamiento],
          children: [
            {
              path: "/personas/reclutamiento/busquedas/list",
              title: "Ofertas de Trabajo",
              icontype: "work_outline",
              requiredRoles: [...navRoles.personas.reclutamiento],
            },
            {
              path: "/personas/reclutamiento/candidatos/list",
              title: "Candidatos",
              icontype: "person_search",
              requiredRoles: [...navRoles.personas.candidatos],
            },
          ],
        },
      ],
    },
    {
      path: "/proyecto",
      title: "Proyecto",
      type: "sub",
      icontype: "assignment",
      collapse: "proyecto",
      roles: [...navRoles.proyecto.any],
      children: [
        {
          path: "/proyecto/list",
          title: "Mantención de Proyectos",
          requiredRoles: [...navRoles.proyecto.mantencion],
        },
        {
          path: "/proyecto/clientes",
          title: "Mantención de Clientes",
          icontype: "business",
          requiredRoles: [AppProperties.CLIENT_READ],
        },
        {
          path: "",
          title: "Mis Aprobaciones",
          type: "sub",
          icontype: "task_alt",
          collapse: "mis-aprobaciones",
          requiredRoles: [...navRoles.proyecto.misAprobaciones],
          children: [
            {
              path: "/proyecto/mis-aprobaciones/vacaciones",
              title: "Vacaciones",
              icontype: "beach_access",
            },
            {
              path: "/proyecto/mis-aprobaciones/liquidaciones-subcontrato",
              title: "Liquidaciones Subcontratos",
              icontype: "receipt_long",
              requiredRoles: [...navRoles.proyecto.liquidacionesSubcontrato],
            },
          ],
        },
        {
          path: "",
          title: "Período Activo",
          icontype: "calendar_today",
          action: "periodo-activo",
          requiredRoles: [...navRoles.proyecto.periodoActivo],
        },
      ],
    },
    {
      path: "/time-report",
      title: "Time Report",
      type: "sub",
      icontype: "schedule",
      roles: [...navRoles.timeReport.any],
      collapse: "time-report",
      children: [
        {
          path: "/time-report/form",
          title: "Cargar horas",
        },
        {
          path: "/time-report/bulk-load",
          title: "Carga masiva",
          requiredRoles: [...navRoles.timeReport.migrator],
        },
      ],
    },
    {
      path: "/reportes",
      title: "Reportes",
      type: "sub",
      icontype: "analytics",
      roles: [...navRoles.reportes.any],
      collapse: "reportes",
      children: [
        {
          path: "",
          title: "Cargable & TR",
          type: "sub",
          icontype: "folder_open",
          requiredRoles: [...navRoles.reportes.cargableTr],
          children: [
            {
              path: "/reportes/reportes-service-line",
              title: "Service Line",
            },
            {
              path: "/reportes/reportes-proyecto",
              title: "Proyectos",
            },
            {
              path: "/reportes/reporte-carga-tr",
              title: "Carga TR",
            },
            {
              path: "/reportes/reporte-cargabilidad",
              title: "Cargabilidad",
            },
            {
              path: "/reportes/reporte-estado-carga",
              title: "Estado de Carga",
            },
          ],
        },
        {
          path: "/reportes/reporte-vacaciones",
          title: "Vacaciones",
          icontype: "beach_access",
          requiredRoles: [...navRoles.reportes.vacaciones],
        },
      ],
    },
    {
      path: "/admin",
      title: "Administración",
      type: "sub",
      icontype: "admin_panel_settings",
      collapse: "admin",
      roles: [...navRoles.admin.any],
      children: [
        {
          path: "/admin/usuarios",
          title: "Usuarios",
          icontype: "people",
          requiredRoles: [...navRoles.admin.usuarios],
        },
        {
          path: "/admin/perfiles",
          title: "Perfiles",
          icontype: "admin_panel_settings",
          requiredRoles: [...navRoles.admin.perfiles],
        },
        {
          path: "/admin/roles",
          title: "Roles",
          icontype: "security",
          requiredRoles: [...navRoles.admin.roles],
        },
        {
          path: "/admin/time-report-status",
          title: "Carga de Horas",
          icontype: "security",
          requiredRoles: [...navRoles.admin.timesheet],
        },
        {
          path: "/admin/api-keys",
          title: "API Keys",
          icontype: "vpn_key",
          requiredRoles: [...navRoles.admin.apiKeys],
        },
        {
          path: "/admin/compania",
          title: "Compañías",
          icontype: "business",
          requiredRoles: [...navRoles.admin.compania],
        },
      ],
    },
    {
      path: "/configuracion",
      title: "Configuración",
      type: "sub",
      icontype: "settings",
      collapse: "configuracion",
      roles: [...navRoles.configuracion.any],
      children: [
        {
          path: "",
          title: "Parámetros",
          type: "sub",
          icontype: "settings",
          collapse: "configuracion-sub",
          requiredRoles: [...navRoles.configuracion.feriados],

          children: [
            {
              path: "/configuracion/pais",
              title: "Países",
              icontype: "flag",
            },
            {
              path: "/configuracion/calendario",
              title: "Calendario Laboral",
              icontype: "calendar_month",
            },
            {
              path: "/configuracion/feriados",
              title: "Feriados",
              icontype: "event",
            },
          ],
        },
        {
          path: "/configuracion/parametros-generales",
          title: "Parámetros Generales",
          icontype: "tune",
          requiredRoles: [...navRoles.configuracion.parametrosGenerales],
        },
      ],
    },
  ];
}
